// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DatabaseManager.css */

/* Collection sidebar sticky positioning */
.collections-sidebar-container {
  position: sticky !important;
  top: 0 !important;
  height: 100vh !important;
  overflow: hidden !important;
}

.collections-sidebar-box {
  height: 100vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.collections-sidebar-header {
  flex-shrink: 0 !important;
  border-bottom: 1px solid #f4f4f4 !important;
}

.collections-sidebar-body {
  flex: 1 1 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  padding: 10px !important;
}

/* Collection search fixed at top */
.collection-search {
  flex-shrink: 0 !important;
  margin-bottom: 15px !important;
  position: sticky !important;
  top: 0 !important;
  background: white !important;
  z-index: 10 !important;
  padding-bottom: 5px !important;
}

.collection-search input {
  border-radius: 3px !important;
  border: 1px solid #ddd !important;
  transition: all 0.2s ease !important;
}

.collection-search input:focus {
  border-color: #007cba !important;
  box-shadow: 0 0 0 1px rgba(0, 124, 186, 0.2) !important;
  outline: none !important;
}

/* Collections list scrollable */
.collections-list-container {
  flex: 1 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.collections-list-container::-webkit-scrollbar {
  width: 6px !important;
}

.collections-list-container::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 3px !important;
}

.collections-list-container::-webkit-scrollbar-thumb {
  background: #c1c1c1 !important;
  border-radius: 3px !important;
}

.collections-list-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

/* Mobile sidebar toggle button - hidden by default */
.mobile-sidebar-toggle {
  display: none !important;
}

/* Mobile responsive design */
@media (max-width: 768px) {
  .collections-sidebar-container {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    width: 280px !important;
    height: 100vh !important;
    background: white !important;
    z-index: 1050 !important;
    box-shadow: 2px 0 10px rgba(0,0,0,0.1) !important;
    transform: translateX(-100%) !important;
    transition: transform 0.3s ease-in-out !important;
  }
  
  .collections-sidebar-container.sidebar-open {
    transform: translateX(0) !important;
  }
  
  .collections-sidebar-overlay {
    display: none !important;
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(0,0,0,0.5) !important;
    z-index: 1040 !important;
  }
  
  .collections-sidebar-overlay.show {
    display: block !important;
  }
  
  .mobile-sidebar-toggle {
    display: block !important;
    position: fixed !important;
    top: 70px !important;
    left: 15px !important;
    z-index: 1060 !important;
    background: #007cba !important;
    color: white !important;
    border: none !important;
    border-radius: 50% !important;
    padding: 12px !important;
    font-size: 18px !important;
    cursor: pointer !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;
    width: 50px !important;
    height: 50px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  .mobile-sidebar-toggle:hover {
    background: #005a8b !important;
    transform: scale(1.05) !important;
  }
  
  .mobile-documents-container {
    padding-left: 0 !important;
    padding-top: 50px !important;
  }
  
  .collections-sidebar-header {
    padding-right: 40px !important;
  }
  
  .sidebar-close-btn {
    display: block !important;
    position: absolute !important;
    top: 15px !important;
    right: 15px !important;
    background: none !important;
    border: none !important;
    font-size: 20px !important;
    cursor: pointer !important;
    color: #666 !important;
    z-index: 10 !important;
  }
}

@media (min-width: 769px) {
  .mobile-sidebar-toggle {
    display: none !important;
  }
  
  .sidebar-close-btn {
    display: none !important;
  }
  
  .collections-sidebar-overlay {
    display: none !important;
  }
}

/* Enhanced search query textarea */
.query-textarea {
  font-family: 'Monaco', 'Consolas', 'Lucida Console', monospace !important;
  font-size: 13px !important;
  line-height: 1.4 !important;
  resize: vertical !important;
  min-height: 80px !important;
  background-color: #fafafa !important;
  border: 2px solid #ddd !important;
  border-radius: 4px !important;
  padding: 8px 12px !important;
  transition: all 0.2s ease !important;
}

.query-textarea:focus {
  border-color: #007cba !important;
  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.2) !important;
  background-color: #fff !important;
  outline: none !important;
}

.query-textarea::placeholder {
  color: #999 !important;
  font-style: italic !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  max-height: 90%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.json-editor-modal {
  width: 800px;
  height: 600px;
}

.cleanup-modal {
  width: 500px;
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #666;
}

.modal-body {
  padding: 20px;
  flex: 1 1;
  overflow-y: auto;
}

.modal-footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  background-color: #f8f9fa;
}

.json-editor {
  width: 100%;
  height: 400px;
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  resize: none;
  outline: none;
  background-color: #f8f9fa;
}

.json-editor.invalid {
  border-color: #dc3545;
  background-color: #fff5f5;
}

.json-editor:focus {
  border-color: #007cba;
  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.1);
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.collections-sidebar {
  padding: 0;
  max-height: 600px;
  overflow-y: auto;
}

.collections-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.collection-item {
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.collection-item:hover {
  background-color: #f0f7ff;
}

.collection-item.active {
  background-color: #007cba;
  color: white;
}

.collection-info {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.collection-name {
  font-weight: 500;
  font-size: 14px;
}

.collection-count {
  font-size: 12px;
  opacity: 0.7;
  margin-top: 2px;
}

.collection-stats {
  font-size: 14px;
  color: #666;
  font-weight: normal;
  margin-left: 10px;
}

.box-tools {
  display: flex;
  gap: 10px;
}

.controls-row {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.controls-row label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.documents-container {
  min-height: 300px;
}

.loading-state {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  display: block;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

.documents-table {
  font-size: 13px;
}

.documents-table th {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  font-weight: 600;
}

.document-id {
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  word-break: break-all;
  color: #666;
}

.document-preview {
  font-family: 'Monaco', 'Consolas', monospace;
  font-size: 11px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 3px;
  padding: 8px;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.action-buttons {
  display: flex;
  gap: 5px;
}

.action-buttons .btn {
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1.2;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.time-input-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.warning-message {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #856404;
  padding: 15px;
  border-radius: 4px;
  margin-top: 20px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.warning-message i {
  color: #f39c12;
  font-size: 18px;
  margin-top: 2px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #007cba;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #0056b3;
}

.btn-success {
  background-color: #28a745;
  color: white;
}

.btn-success:hover:not(:disabled) {
  background-color: #218838;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning:hover:not(:disabled) {
  background-color: #e0a800;
}

.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c82333;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 12px;
}

.btn-xs {
  padding: 3px 6px;
  font-size: 11px;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 20px 0;
  justify-content: center;
}

.page-item {
  margin: 0 2px;
}

.page-link {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  background-color: white;
  color: #007cba;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
}

.page-link:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-item.active .page-link {
  background-color: #007cba;
  border-color: #007cba;
  color: white;
}

.page-item.disabled .page-link {
  color: #6c757d;
  background-color: white;
  border-color: #dee2e6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .json-editor-modal {
    width: 95%;
    height: 80%;
  }
  
  .cleanup-modal {
    width: 95%;
  }
  
  .controls-row {
    padding: 10px;
  }
  
  .controls-row .col-md-4 {
    width: 100%;
    margin-bottom: 15px;
  }
  
  .time-input-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}

/* Scrollbar Styling */
.collections-sidebar::-webkit-scrollbar,
.json-editor::-webkit-scrollbar,
.document-preview::-webkit-scrollbar {
  width: 6px;
}

.collections-sidebar::-webkit-scrollbar-track,
.json-editor::-webkit-scrollbar-track,
.document-preview::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.collections-sidebar::-webkit-scrollbar-thumb,
.json-editor::-webkit-scrollbar-thumb,
.document-preview::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.collections-sidebar::-webkit-scrollbar-thumb:hover,
.json-editor::-webkit-scrollbar-thumb:hover,
.document-preview::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/DatabaseManager/DatabaseManager.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,0CAA0C;AAC1C;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;EACvD,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,oBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,qDAAqD;AACrD;EACE,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,iDAAiD;IACjD,uCAAuC;IACvC,iDAAiD;EACnD;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,sCAAsC;IACtC,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,iDAAiD;IACjD,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;IAC9B,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;EACvD,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,sBAAsB;AACtB;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB","sourcesContent":["/* DatabaseManager.css */\n\n/* Collection sidebar sticky positioning */\n.collections-sidebar-container {\n  position: sticky !important;\n  top: 0 !important;\n  height: 100vh !important;\n  overflow: hidden !important;\n}\n\n.collections-sidebar-box {\n  height: 100vh !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.collections-sidebar-header {\n  flex-shrink: 0 !important;\n  border-bottom: 1px solid #f4f4f4 !important;\n}\n\n.collections-sidebar-body {\n  flex: 1 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  padding: 10px !important;\n}\n\n/* Collection search fixed at top */\n.collection-search {\n  flex-shrink: 0 !important;\n  margin-bottom: 15px !important;\n  position: sticky !important;\n  top: 0 !important;\n  background: white !important;\n  z-index: 10 !important;\n  padding-bottom: 5px !important;\n}\n\n.collection-search input {\n  border-radius: 3px !important;\n  border: 1px solid #ddd !important;\n  transition: all 0.2s ease !important;\n}\n\n.collection-search input:focus {\n  border-color: #007cba !important;\n  box-shadow: 0 0 0 1px rgba(0, 124, 186, 0.2) !important;\n  outline: none !important;\n}\n\n/* Collections list scrollable */\n.collections-list-container {\n  flex: 1 !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n}\n\n.collections-list-container::-webkit-scrollbar {\n  width: 6px !important;\n}\n\n.collections-list-container::-webkit-scrollbar-track {\n  background: #f1f1f1 !important;\n  border-radius: 3px !important;\n}\n\n.collections-list-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1 !important;\n  border-radius: 3px !important;\n}\n\n.collections-list-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8 !important;\n}\n\n/* Mobile sidebar toggle button - hidden by default */\n.mobile-sidebar-toggle {\n  display: none !important;\n}\n\n/* Mobile responsive design */\n@media (max-width: 768px) {\n  .collections-sidebar-container {\n    position: fixed !important;\n    left: 0 !important;\n    top: 0 !important;\n    width: 280px !important;\n    height: 100vh !important;\n    background: white !important;\n    z-index: 1050 !important;\n    box-shadow: 2px 0 10px rgba(0,0,0,0.1) !important;\n    transform: translateX(-100%) !important;\n    transition: transform 0.3s ease-in-out !important;\n  }\n  \n  .collections-sidebar-container.sidebar-open {\n    transform: translateX(0) !important;\n  }\n  \n  .collections-sidebar-overlay {\n    display: none !important;\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100% !important;\n    height: 100% !important;\n    background: rgba(0,0,0,0.5) !important;\n    z-index: 1040 !important;\n  }\n  \n  .collections-sidebar-overlay.show {\n    display: block !important;\n  }\n  \n  .mobile-sidebar-toggle {\n    display: block !important;\n    position: fixed !important;\n    top: 70px !important;\n    left: 15px !important;\n    z-index: 1060 !important;\n    background: #007cba !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 50% !important;\n    padding: 12px !important;\n    font-size: 18px !important;\n    cursor: pointer !important;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.3) !important;\n    width: 50px !important;\n    height: 50px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n  }\n  \n  .mobile-sidebar-toggle:hover {\n    background: #005a8b !important;\n    transform: scale(1.05) !important;\n  }\n  \n  .mobile-documents-container {\n    padding-left: 0 !important;\n    padding-top: 50px !important;\n  }\n  \n  .collections-sidebar-header {\n    padding-right: 40px !important;\n  }\n  \n  .sidebar-close-btn {\n    display: block !important;\n    position: absolute !important;\n    top: 15px !important;\n    right: 15px !important;\n    background: none !important;\n    border: none !important;\n    font-size: 20px !important;\n    cursor: pointer !important;\n    color: #666 !important;\n    z-index: 10 !important;\n  }\n}\n\n@media (min-width: 769px) {\n  .mobile-sidebar-toggle {\n    display: none !important;\n  }\n  \n  .sidebar-close-btn {\n    display: none !important;\n  }\n  \n  .collections-sidebar-overlay {\n    display: none !important;\n  }\n}\n\n/* Enhanced search query textarea */\n.query-textarea {\n  font-family: 'Monaco', 'Consolas', 'Lucida Console', monospace !important;\n  font-size: 13px !important;\n  line-height: 1.4 !important;\n  resize: vertical !important;\n  min-height: 80px !important;\n  background-color: #fafafa !important;\n  border: 2px solid #ddd !important;\n  border-radius: 4px !important;\n  padding: 8px 12px !important;\n  transition: all 0.2s ease !important;\n}\n\n.query-textarea:focus {\n  border-color: #007cba !important;\n  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.2) !important;\n  background-color: #fff !important;\n  outline: none !important;\n}\n\n.query-textarea::placeholder {\n  color: #999 !important;\n  font-style: italic !important;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  max-width: 90%;\n  max-height: 90%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.json-editor-modal {\n  width: 800px;\n  height: 600px;\n}\n\n.cleanup-modal {\n  width: 500px;\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f8f9fa;\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #999;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.2s;\n}\n\n.close-btn:hover {\n  background-color: #f0f0f0;\n  color: #666;\n}\n\n.modal-body {\n  padding: 20px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.modal-footer {\n  padding: 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  background-color: #f8f9fa;\n}\n\n.json-editor {\n  width: 100%;\n  height: 400px;\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 15px;\n  resize: none;\n  outline: none;\n  background-color: #f8f9fa;\n}\n\n.json-editor.invalid {\n  border-color: #dc3545;\n  background-color: #fff5f5;\n}\n\n.json-editor:focus {\n  border-color: #007cba;\n  box-shadow: 0 0 0 2px rgba(0, 124, 186, 0.1);\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 14px;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.collections-sidebar {\n  padding: 0;\n  max-height: 600px;\n  overflow-y: auto;\n}\n\n.collections-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.collection-item {\n  padding: 12px 15px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.collection-item:hover {\n  background-color: #f0f7ff;\n}\n\n.collection-item.active {\n  background-color: #007cba;\n  color: white;\n}\n\n.collection-info {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.collection-name {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.collection-count {\n  font-size: 12px;\n  opacity: 0.7;\n  margin-top: 2px;\n}\n\n.collection-stats {\n  font-size: 14px;\n  color: #666;\n  font-weight: normal;\n  margin-left: 10px;\n}\n\n.box-tools {\n  display: flex;\n  gap: 10px;\n}\n\n.controls-row {\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n}\n\n.controls-row label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: #333;\n}\n\n.documents-container {\n  min-height: 300px;\n}\n\n.loading-state {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: #999;\n}\n\n.empty-state i {\n  font-size: 48px;\n  margin-bottom: 15px;\n  display: block;\n}\n\n.empty-state p {\n  font-size: 16px;\n  margin: 0;\n}\n\n.documents-table {\n  font-size: 13px;\n}\n\n.documents-table th {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n  font-weight: 600;\n}\n\n.document-id {\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 11px;\n  word-break: break-all;\n  color: #666;\n}\n\n.document-preview {\n  font-family: 'Monaco', 'Consolas', monospace;\n  font-size: 11px;\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 3px;\n  padding: 8px;\n  margin: 0;\n  max-height: 150px;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 5px;\n}\n\n.action-buttons .btn {\n  padding: 4px 8px;\n  font-size: 12px;\n  line-height: 1.2;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n}\n\n.time-input-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.warning-message {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  color: #856404;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.warning-message i {\n  color: #f39c12;\n  font-size: 18px;\n  margin-top: 2px;\n}\n\n.btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #007cba;\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.btn-success {\n  background-color: #28a745;\n  color: white;\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: #218838;\n}\n\n.btn-warning {\n  background-color: #ffc107;\n  color: #212529;\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: #e0a800;\n}\n\n.btn-danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: #5a6268;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.btn-xs {\n  padding: 3px 6px;\n  font-size: 11px;\n}\n\n.pagination {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 20px 0;\n  justify-content: center;\n}\n\n.page-item {\n  margin: 0 2px;\n}\n\n.page-link {\n  padding: 8px 12px;\n  border: 1px solid #dee2e6;\n  background-color: white;\n  color: #007cba;\n  text-decoration: none;\n  cursor: pointer;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.page-link:hover:not(:disabled) {\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n\n.page-item.active .page-link {\n  background-color: #007cba;\n  border-color: #007cba;\n  color: white;\n}\n\n.page-item.disabled .page-link {\n  color: #6c757d;\n  background-color: white;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .json-editor-modal {\n    width: 95%;\n    height: 80%;\n  }\n  \n  .cleanup-modal {\n    width: 95%;\n  }\n  \n  .controls-row {\n    padding: 10px;\n  }\n  \n  .controls-row .col-md-4 {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n  \n  .time-input-group {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n  }\n}\n\n/* Scrollbar Styling */\n.collections-sidebar::-webkit-scrollbar,\n.json-editor::-webkit-scrollbar,\n.document-preview::-webkit-scrollbar {\n  width: 6px;\n}\n\n.collections-sidebar::-webkit-scrollbar-track,\n.json-editor::-webkit-scrollbar-track,\n.document-preview::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.collections-sidebar::-webkit-scrollbar-thumb,\n.json-editor::-webkit-scrollbar-thumb,\n.document-preview::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.collections-sidebar::-webkit-scrollbar-thumb:hover,\n.json-editor::-webkit-scrollbar-thumb:hover,\n.document-preview::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
